import {
  jb_article_tool_bar_css_default
} from "./chunk.BEMYSFF2.js";
import {
  reset_css_default
} from "./chunk.YAATWOBE.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Spaceable
} from "./chunk.JI7MO3NT.js";
import {
  A,
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  n
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-article-tool-bar/jb-article-tool-bar.ts
var JbArticleToolBar = class extends Spaceable(i) {
  _getContentSpacingProperties() {
    return { grid: true, colsMdUp: 8, type: "article-toolbar" };
  }
  _handleClick(evt, icon) {
    if (icon !== "jb-mail-icon") {
      return;
    }
    this.dispatchEvent(
      new CustomEvent("jb-article-tool-bar:mail-icon-clicked", {
        bubbles: true,
        composed: true,
        detail: {
          returnFocusTo: evt.target
        }
      })
    );
  }
  render() {
    return b`
      <jb-article-share-bar
        .articleTitle=${this.articleTitle}
        .mailSubject=${this.mailSubject}
        .shareServices=${this.shareServices}
        .title=${this.shareBarLabel}
        .url=${this.url}
      ></jb-article-share-bar>
      <jb-button-panel>
        ${this.buttons.map(
      (item) => b`
            <jb-button-secondary @click=${(evt) => this._handleClick(evt, item.icon)}>
              ${item.icon === "jb-mail-icon" ? b`<jb-icon iconName="material:mail"></jb-icon>` : A}
              ${item.label}</jb-button-secondary
            >
          `
    )}
      </jb-button-panel>
    `;
  }
};
JbArticleToolBar.styles = [reset_css_default, jb_article_tool_bar_css_default];
__decorateClass([
  n()
], JbArticleToolBar.prototype, "articleTitle", 2);
__decorateClass([
  n({ type: Array })
], JbArticleToolBar.prototype, "buttons", 2);
__decorateClass([
  n()
], JbArticleToolBar.prototype, "mailSubject", 2);
__decorateClass([
  n()
], JbArticleToolBar.prototype, "shareBarLabel", 2);
__decorateClass([
  n({ type: Array })
], JbArticleToolBar.prototype, "shareServices", 2);
__decorateClass([
  n()
], JbArticleToolBar.prototype, "url", 2);
JbArticleToolBar = __decorateClass([
  customElement("jb-article-tool-bar")
], JbArticleToolBar);

export {
  JbArticleToolBar
};
